export const touchEvent = 'click'
